module.exports = __webpack_public_path__ + "static/img/jinrong1.acb28ba2.png";